module.exports = __webpack_public_path__ + "static/media/lumbering23.69b23356.jpg";